import type { CurrentUser } from "../api";

export interface AuthState {
  user: CurrentUser;
  csrfToken: string;
}

export interface LoginResponse {
  user: CurrentUser;
  csrf_token: string;
  return_to?: string;
}

export function completeLogin(
  result: LoginResponse,
  callbacks: {
    onAuthenticated: (auth: AuthState) => void;
    replaceLocation: (target: string) => void;
  }
): void {
  if (result.return_to) {
    callbacks.replaceLocation(result.return_to);
    return;
  }
  callbacks.onAuthenticated({
    user: result.user,
    csrfToken: result.csrf_token
  });
}
